import React, {forwardRef} from 'react';
import {Flex} from 'components';
import css from './header.module.scss';

export const Header = forwardRef(({ children, justified, className, middle = true }, ref) =>
  <header className={css('header', className, 'popup-container')} ref={ref}>
    { justified
      ? <Flex className={['justified', middle && 'middle']}>{ children }</Flex>
      : children
    }
  </header>
);
